// React
import React from 'react'
import StripeCheckout from 'react-stripe-checkout'
// GraphQL
import { compose, graphql } from 'react-apollo'
// GraphQL queries
import { accountPaidQuery } from '../../graphql/queries/payment'
// GraphQL mutations
import { stripeTokenMutation } from '../../graphql/mutations/payment'
// GraphQL subscriptions
import { accountPaidSubscription } from '../../graphql/subscriptions/payment'
// Components
import Loading from '../Display/Loading'
import Modal from '../Display/Modal'

class Stripe extends React.Component {

	constructor(props) {
		super(props)
		this.state = {
			modal: { status: 'hidden', title: '', text: '', action: { text: '', func: () => null }, cancel: { text: '', func: () => null }, loading: false },
			success: false
		}
	}

	componentWillReceiveProps(nextProps) {
		// Subscribe to see if `accountPaid` becomes `true`
		if (!nextProps.data.loading && nextProps.data.accountPaidQuery && !this.purchaseSubscription) {
			const userId = nextProps.user.id
			this.purchaseSubscription = nextProps.data.subscribeToMore({
				document: accountPaidSubscription,
				variables: { userId },
				updateQuery: (previousState) => {
					this.setState({
						modal: {
							status: 'visible',
							title: 'upgrade successful',
							text: 'thank you for upgrading!',
							action: { text: 'Continue', func: () => {
								this.closeModal()
								this.props.redux.nav.setPage('')
							} },
							cancel: { text: '', func: null },
							loading: false
						},
						success: true
					})
					// Cancel subscription
					this.purchaseSubscription()
				},
				onError: (err) => console.error(err)
			})
		}
	}

	onToken = (token) => {
		const paymentStripeToken = token.id
		const userId = this.props.user.id
		this.setState({
			modal: {
				status: 'visible',
				title: 'purchasing...',
				text: 'please wait while your app is being purchased. sometimes this can take up to 10 seconds, so thank you for being patient.',
				action: { text: '', func: null },
				cancel: { text: '', func: null },
				loading: true
			}
		})
		this.props.stripeTokenMutation({ variables: { userId, paymentStripeToken } })
			.then(() => {
				// Wait 16 seconds for `accountPaid` field to be updated via subscription
				setTimeout(() => {
					if (!this.state.success) {
						this.setState({
							modal: {
								status: 'visible',
								title: 'upgrade failed',
								text: 'the upgrade was not successful. please contact customer support for further assistance.',
								action: { text: 'Contact Support', func: () => {
									this.closeModal()
									window.Intercom('show')
								} },
								cancel: { text: 'Close', func: () => this.closeModal() },
								loading: false
							}
						})
					}
				}, 16000)
			})
			.catch((err) => console.error(err))
	}


	// MODAL
	closeModal = () => this.setState({ modal: { status: 'hidden', title: '', text: '', action: { text: '', func: () => null }, cancel: { text: '', func: () => null } } })


	render() {
		if (this.props.data.loading) {
			return <Loading status={true} text='loading...' />
		}
		const { modal } = this.state
		const stripeKey = 'pk_live_YsFhjt6CyqIJkFw1I85eNiT5'
		// const stripeKey = 'pk_test_xxtMsNnKkNzVxlTAsSSXAwHt'
		return (
			<div>
				<Modal
					status={modal.status}
					title={modal.title}
					text={modal.text}
					action={{ text: modal.action.text, func: modal.action.func }}
					cancel={{ text: modal.cancel.text, func: modal.cancel.func }}
					loading={modal.loading}
				/>
				<StripeCheckout
					name='Moon Sign App'
					description='Discover your astrological moon sign'
					image='https://uploads-ssl.webflow.com/5a02369828f39d0001491d1b/5a6d04287bd20a00018453e2_moon.png'
					ComponentClass='div'
					panelLabel='Upgrade'
					amount={999}
					currency='USD'
					stripeKey={stripeKey}
					email={this.props.user.email}
					shippingAddress={false}
					billingAddress={true}
					zipCode={true}
					allowRememberMe
					token={this.onToken}
					reconfigureOnUpdate={false}
					triggerEvent='onTouchTap'
				>
					<div className='capps-button primary'>
						Upgrade
					</div>
				</StripeCheckout>
			</div>
		)
	}
}

export default compose(
	graphql(accountPaidQuery, { options: ({ user }) => ({ variables: { userFilter: { id: user.id } } }) }),
	graphql(stripeTokenMutation, { name: 'stripeTokenMutation' })
)(Stripe)



// WEBPACK FOOTER //
// ./src/Components/Payment/Stripe.js